import type { HTTPRequest, HTTPResponse } from '@carboncopyco/types';
import { getContentSha256Header } from './utils';

const createUrlMatchSelector = (request?: HTTPRequest) => ({
  type: 'UrlMatch',
  applyTo: 'request',
  arguments: {
    mode: 'exact',
    match: request?.url ?? '',
  },
});

const createMethodMatchSelector = (request?: HTTPRequest) => ({
  type: 'MethodMatch',
  applyTo: 'request',
  arguments: {
    match: request?.method ?? '',
  },
});

const createContentContainsSelector = () => ({
  type: 'ContentContains',
  applyTo: 'request',
  arguments: {
    match: 'PLACE_CONTENT_HERE',
  },
});

export const createMatchContentSha256Selector = (response?: HTTPResponse) => ({
  type: 'MatchContentSha256',
  applyTo: 'response',
  arguments: {
    match: [getContentSha256Header(response) ?? ''],
  },
});

export const createInitialSelectors = (request?: HTTPRequest) =>
  [
    createUrlMatchSelector(request),
    createMethodMatchSelector(request),
    !request && createContentContainsSelector(),
  ].filter(Boolean);

export const createSelectorsFromScratch = () => {
  return [
    {
      type: 'SELECTOR_TYPE',
      applyTo: 'request',
      arguments: {},
    },
  ];
};
